import React from 'react';
import singleSearchItem from 'components/Hocs/GroupsSearchNewCollector/SingleSearchItem';

import SearchResult from './SearchResult';

const Content = singleSearchItem(SearchResult);

export default props => (
  <Content
    {...props}
    groupName="faq"
    listReduceName="faqContents.lists.faqContentsSearchList"
  />
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentSearch/SearchResult/index.js